import styled from 'styled-components';

import type {ChartSegmentColor} from '../types/ColorSegmentColor';

interface ColorSegmentProps {
  $color: ChartSegmentColor;
  $isFirst?: boolean;
  $isLast?: boolean;
}

export const ColorSegment = styled.div<ColorSegmentProps>`
  height: ${({theme}) => theme.getSize(2)};
  width: 100%;
  background-color: ${(props) => props.$color};
  border-top-left-radius: ${(props) => (props.$isFirst ? props.theme.getSize(1) : '0')};
  border-bottom-left-radius: ${(props) => (props.$isFirst ? props.theme.getSize(1) : '0')};
  border-top-right-radius: ${(props) => (props.$isLast ? props.theme.getSize(1) : '0')};
  border-bottom-right-radius: ${(props) => (props.$isLast ? props.theme.getSize(1) : '0')};
`;
